module.exports = __webpack_public_path__ + "img/sus_users_April.73e8b0ba.png";